import React from "react";
import { render } from "Utils/react-utils";
import { Provider } from "react-redux";
import store from "../../store";

import RegisterDapp from "Components/landing/home/RegisterDapp";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "../../context/theme";

export async function initRegisterBtn() {
	const targetElement = document.querySelectorAll(".register-dapp");
	if (targetElement.length > 0) {
		targetElement.forEach((el) => {
			render(
				<Provider store={store}>
					<ThemeProvider theme={theme}>
						<StyledEngineProvider injectFirst>
							<RegisterDapp textContent={"Register"} />
						</StyledEngineProvider>
					</ThemeProvider>
				</Provider>,
				el,
			);
		});
	}
}
